import type { ThemeOptions } from '@/utils/material';
import { createContext } from 'react';
import type ReactGA from 'react-ga';

export type SdkConfig = {
  shadowRoot?: boolean;
  elementSelector?: string;
  onlySearchBar?: boolean;
  theme?: ThemeOptions;
  redirectSearchTo?: string;
  token?: string;
  trackers?: ReactGA.Tracker[];
  shadowMainHeight?: string;
  unitParameters?: {
    communityId?: number[];
  };
};

export interface SDKContextProps {
  config: SdkConfig | undefined;
}

export const SDKContext = createContext<SDKContextProps>({
  config: undefined,
});
